import { Link, useSearchParams, useLoaderData } from '@remix-run/react';
import {
    PIN_TYPE_PARAM_NAME,
    PIN_TITLE_AND_TYPE,
} from '~/modules/design-board/config/design-board-config';
import type { FilterDropdownData } from '~/modules/design-board/type/design-board-types';
import type { loader } from '~/routes/_app.member.design-boards.pins';
import { DesignBoardPinTargetType } from 'generated/graphql';
import { isValueOfObject } from '~/modules/design-board/util';

const dropdownDefaultItem = {
    as: Link,
    to: '.',
    header: 'All pins',
};

const usePinFilterDropdown = (): FilterDropdownData => {
    const [searchParams] = useSearchParams();
    const pinTargetType = searchParams.get(PIN_TYPE_PARAM_NAME);
    const isValidPinType = isValueOfObject(
        pinTargetType,
        DesignBoardPinTargetType
    );

    let selectedItem: FilterDropdownData['selectedItem'] = dropdownDefaultItem;

    const { pinCounts } = useLoaderData<typeof loader>();

    const items = [
        dropdownDefaultItem,
        ...PIN_TITLE_AND_TYPE.map((item) => {
            const newParams = new URLSearchParams({
                ...(item.type && { [PIN_TYPE_PARAM_NAME]: item.type }),
                page: '1',
            });

            const hasPinItemType = item.type ? pinCounts[item.type] > 0 : true;

            const newItem = {
                as: Link,
                to: `?${newParams.toString()}`,
                header: item.title,
                disabled: !hasPinItemType,
                className: hasPinItemType ? '' : 'disabled',
                onClick: (e: React.SyntheticEvent) => {
                    if (!hasPinItemType) {
                        e.preventDefault();
                    }
                },
                prefetch: 'intent',
            };

            if (isValidPinType && item.type === pinTargetType) {
                selectedItem = newItem;
            }

            return newItem;
        }),
    ];

    const defaultItem = items[0];

    const placeholder = defaultItem?.header;

    return { items, selectedItem, defaultItem, placeholder };
};

export { usePinFilterDropdown };
